import { debug } from "util";

cb.define([], function () {
  var AA_aa_posdevicesetting_VM_extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    getImageSize: function (mode) {
      if (mode === 'pic')
      return '1920*1080';
      return '1310*984';
    },
    init: function (viewmodel) {
      var self=this;
      viewmodel.get('dualScreenSetting').setState('defaultSelectedRowIndexes', true);
      var dualScreenSettingRowModel = viewmodel.get('dualScreenSetting').getEditRowModel();
      dualScreenSettingRowModel.get('dScreenEnabled').on('afterValueChange', function (args){
        viewmodel.get('advertFile').setState('imageSize', self.getImageSize(args.value.value));
      });
      viewmodel.on('afterLoadData', function () {
        if (viewmodel.getParams().mode === 'add') {
          viewmodel.get('dualScreenSetting').appendRow();
          viewmodel.get('advertFile').setState('imageSize', self.getImageSize());
        } else {
          var mode = dualScreenSettingRowModel.get('dScreenEnabled').getValue();
          viewmodel.get('advertFile').setState('imageSize', self.getImageSize(mode));
        }
        if (viewmodel.getParams().action === 'copy') {
          viewmodel.get("templateType").setValue(1);
        }
       if (viewmodel.get('templateType').getValue() == '0'){
            debugger;
            viewmodel.execute('updateViewMeta', {code:'aa_suitablestoreEdit',visible:false});
            viewmodel.get('btnDelete').setVisible(false);
       }
       
      

      });
      viewmodel.on('beforeSave', function() {
        if(!self.saveChecked(viewmodel)) {
          return false;
        }
      });
      viewmodel.on('beforeSaveandadd', function () {
        if(!self.saveChecked(viewmodel)){
          return false;
        }
      });
    },
    saveChecked:function (viewmodel) {
      if(viewmodel.get("dualScreenSetting").getData()[0]["carouseLong"]<=0){
        cb.utils.alert('轮播时长必须大于0','error');
        return false;
      };
      if (viewmodel.get('suitableStore').getRows().length === 0 && viewmodel.get('templateType').getValue() != '0'){
        cb.utils.alert('门店必输！','error');
        return false;
      }else{
        return true;
      }
    }
  }
  try {
    module.exports = AA_aa_posdevicesetting_VM_extend;
  } catch (error) {

  }
  return AA_aa_posdevicesetting_VM_extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_posdevicesetting_VM.Extend.js